<template>
  <div style="padding-bottom: 1rem;">
    <IndicatorCab
      cab="Producto Estratégico"
      :text="datosTabla.strategicProduct"
    />
    <IndicatorCab cab="Indicador" :text="datosTabla.indicatorName" />
    <IndicatorCab
      cab="Fórmula de Calculo"
      :text="datosTabla.indicatorFormula"
    />

    <IndicatorTable :items="datosTabla.itemsTabla" />
    <hr>
  </div>
</template>
<script>
import IndicatorCab from "./IndicatorCab.vue";
import IndicatorTable from "./IndicatorTable.vue";
export default {
  components: {
    IndicatorCab,
    IndicatorTable,
  },
  props: ["datosTabla"],
  data() {
    return {};
  },
};
</script>
<style>
tr:hover {
  background: none;
}
</style>
